<!--begin::Address Modal component-->
<template>
    <div v-if="showModal" class="modal show fade address-modal" v-bind:id="addressType" tabindex="-1" role="dialog" aria-labelledby="addressModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <Form ref="form" class="form" @submit="saveAddress" :validation-schema="schema" v-slot="{errors}">
                    <div class="modal-header">
                        <h5 class="modal-title font-weight-bolder font-size-h5" id="exampleModalLabel">{{addressTitle}}</h5>
                        <button type="button" class="close" data-dismiss="modal" @click.prevent="formReset" aria-label="Close">
                        </button>
                        <label class="checkbox">
                            <input type="checkbox" v-model="copyDeliveryAddress">
                            <span class="mr-2"></span> {{copyTitle}}
                        </label>
                    </div>
                    <div class="modal-body ml-5 mr-5 px-3 px-md-5">
                        <div class="form-group row" :class="{'d-none' : d_none }">
                            <select class="form-control"  v-model="selectedDeliveryAddress" @change="changeSelectedAddress()">
                               <option value="">Please Select Address</option>
                               <option v-for="(address, index) in dropdownAddresses" :key="index" :value="address">
                                   {{address.name}},{{address.city}},{{address.state}},{{address.zip_code}},{{address.address}}.
                               </option>
                            </select>
                        </div>
                        <div class="form-group row">
                            <label class="font-weight-bolder font-size-lg">{{$t('name')}}*</label>
                            <Field name="name" type="text" v-model="name"  placeholder="Enter full name"  class="form-control form-elements" :class="{ 'is-invalid': errors.name }"  />
                            <ErrorMessage  name="name" class="error-message" />
                        </div>
                        <div class="form-group row">
                            <label class="font-weight-bolder font-size-lg">{{$t('address')}}*</label>
                            <Field name="address" type="text" v-model="address"  placeholder="Enter Address"  class="form-control form-elements" :class="{ 'is-invalid': errors.address }" />
                            <ErrorMessage  name="address" class="error-message" />
                        </div>
                        <div class="form-group row">
                            <label class="font-weight-bolder font-size-lg">{{$t('address_2')}}</label>
                            <Field name="address_2" type="text" v-model="address_2"  placeholder="Enter Address 2"  class="form-control form-elements" />
                             <ErrorMessage  name="address_2" class="error-message" />
                        </div>
                        <div class="form-group row">
                            <div class="col-12 col-lg-6 px-0 px-lg-0"> 
                                <label class="font-weight-bolder font-size-lg">{{$t('country')}}*</label> 
                                <select 
                                class="form-control form-elements" 
                                @change="onCountryChange($event)" 
                                v-model="country" 
                                name="country" 
                                > 
                                <option v-for="(country_name, country_code) in countries" :key="country_code" v-bind:value="country_code">{{ country_name }}</option> 
                            </select> 
                        </div> 
                            <div class="col-12 col-lg-6 pl-lg-3">
                                <div v-show="country == 'United States'">
                                    <label class="font-weight-bolder font-size-lg">{{$t('state_region')}}*</label>
                                    <select class="form-control form-elements" v-model="state" name="state"  key="us-states">
                                        <option v-for="(state_name, state_code) in states" :key="state_code" v-bind:value="state_code">{{ state_name }}</option>
                                    </select>
                                </div>
                                <div v-show="country !== 'United States'">
                                    <label class="font-size-lg font-weight-bolder">{{$t('state_region')}}</label>
                                    <Field name="state" type="text" v-model="state"  placeholder="Enter State"  class="form-control form-elements" :class="{ 'is-invalid': errors.state }" />
                                    <ErrorMessage  name="state" class="error-message" />
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12 col-lg-6 px-0 px-lg-0">
                                <label class="font-weight-bolder font-size-lg">{{$t('city')}}*</label>
                                <Field name="city" type="text" v-model="city"  placeholder="Enter city"  class="form-control form-elements" :class="{ 'is-invalid': errors.city }" />
                                <ErrorMessage  name="city" class="error-message" />
                            </div>
                            <div class="col-12 col-lg-6 pl-lg-3">
                                <label class="font-weight-bolder font-size-lg">{{$t('postal_zipcode')}}*:</label>
                                <Field name="zip_code" type="text" v-model="zip_code"  placeholder="Enter Zip Code"  class="form-control form-elements" :class="{ 'is-invalid': errors.zip_code }" />
                                <ErrorMessage  name="zip_code" class="error-message" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12 col-lg-6 px-0 px-lg-0">
                                <label class="font-weight-bolder font-size-lg">{{$t('phone')}}<span v-if="$store.state.brand_settings.contact_info_for_shipping_and_billing == '1'">*</span>:</label>
                                <Field name="phone" type="text" v-model="phone"  placeholder="Enter phone"  class="form-control form-elements" :class="{ 'is-invalid': errors.phone }" />
                                <ErrorMessage  name="phone" class="error-message" />
                            </div>
                            <div class="col-12 col-lg-6 pl-lg-3">
                                <label class="font-weight-bolder font-size-lg">{{$t('email')}}<span v-if="$store.state.brand_settings.contact_info_for_shipping_and_billing == '1'">*</span>:</label>
                                <Field name="email" type="text" v-model="email"  placeholder="Enter email"  class="form-control form-elements" :class="{ 'is-invalid': errors.email }" />
                                <ErrorMessage  name="email" class="error-message" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary rounded-0" data-dismiss="modal" @click.prevent="formReset">{{$t('close')}}</button>
                        <button type="submit" :class="{'btn btn-primary rounded-0': true, 'spinner spinner-white spinner-right disabled' : this.spinner }" :disabled="buttonDisable">{{$t('save')}}</button>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>
<!--end::Address Modal component-->

<script>
    import AddressAPIService from '@/js/api/address/address';
    import { Field, Form, ErrorMessage } from 'vee-validate';
    import * as yup from 'yup';
    import { ADDRESS_CONFIG } from '@/js/config.js';
    import eventBus from '@/js/utils/eventBus';

    export default {
        name: 'AddressComponent',
        components: {
            Form,Field,ErrorMessage,
        },
        props: [
            "customerId",
            "addressType",
            "modalTitle",
            "parentmessage",
            "showModal"
        ],
        data() {
            return {
                name: '',
                address: '',
                address_2: '',
                city:'',
                state: '', // TODO: Make it dynamic.
                zip_code: '',
                country: localStorage.getItem('BrandDefaultCurrency'), // We get brand default country through local storage
                email:'',
                phone:'',
                addressId: '',
                spinner: false,
                buttonDisable: false,
                dropdownAddresses:[],
                countries: ADDRESS_CONFIG.COUNTRIES,
                states:[],
                action_mode: 'shipping-address-add',
                copyDeliveryAddress:false,
                numeric: '',
                d_none: true,
                copyTitle: '',
                selectedDeliveryAddress: '',
                custId: this.customerId,
            };
        },
        computed: {
            addressTitle() {
                return this.modalTitle;
            },
            schema(){
                const isFieldRequired = this.$store.state.brand_settings.contact_info_for_shipping_and_billing == '1';
                return yup.object({
                    name: yup.string().required('Name is required'),
                    address: yup.string().required('Address is required'),
                    state: yup.string().nullable()
                        .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : originalValue))
                        .matches(/(^[a-zA-Z0-9\s.,'-_]*$)+/, {
                            message: 'State is not valid',
                            excludeEmptyString: true
                        }).notRequired(),
                    city: yup.string().required('City is required').matches(/(^[a-zA-Z0-9\s.,'-_#]*$)+/),
                    zip_code: yup.string().required('Zipcode is required'),
                    phone: yup.string()
                        .test('required-if', 'Phone number is required', function(value) {
                            if (isFieldRequired && !value) {
                            return this.createError({ message: 'Phone number is required' });
                            }
                            return true;
                        })
                        .nullable().transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value))
                        .matches(/^[\d()+\-\.\s]+$/, {
                        message: 'Phone number is not valid'
                        }),
                    email: yup.string()
                        .email('Enter a valid email')
                        .test('required-if', 'Email is required', function(value) {
                        if (isFieldRequired && !value) {
                            return this.createError({ message: 'Email is required' });
                        }
                        return true;
                        })
                        .nullable(),   

                });

            }
        },
        watch : {
            copyDeliveryAddress : function (bool){
                if(bool === true){
                    this.d_none =  false;
                }else{
                    this.d_none =  true;
                }
            }
        },
        mounted: function() {
            this.$root.eventBus.on('ShippingAddress::Add', (id=null) => {
                const vm = this;
                if(id){
                    this.custId = id;
                }
                this.name = '';
                this.address = '';
                this.address_2 = '';
                this.city = '';
                this.state = '';
                this.zip_code = '';
                this.email = '';
                this.phone = '';
                this.country = localStorage.getItem('BrandDefaultCurrency'); // We get brand default country through local storage
                this.action_mode = 'shipping-address-add';
                this.copyTitle   = 'Copy from Billing Address';
                this.$nextTick(() => {
                    // this.errors.clear();
                    this.$nextTick(() => {
                        // this.$validator.reset();
                        vm.d_none = true;
                        vm.copyDeliveryAddress = false;
                        vm.selectedDeliveryAddress = '';
                    });
                });
                vm.dropdownAddresses = '';
                // getting billing address
                AddressAPIService.getBillingAddresses( this.custId).then((response) =>  {
                    if(response.data.hasOwnProperty('billingAddresses')){
                        vm.dropdownAddresses = response.data.billingAddresses;
                    }
                })
            })
            this.$root.eventBus.on('ShippingAddress::Edit', (address) => {
                const vm = this;
                this.name = address.name;
                this.address = address.address;
                this.address_2 = address.address_2;
                this.city = address.city;
                this.state = address.state;
                this.zip_code = address.zip_code;
                this.email = address.email;
                this.phone = address.phone;
                this.country = address.country;
                this.addressId = address.id;
                this.action_mode = 'shipping-address-edit';
                this.copyTitle   = 'Copy from Billing Address';
                 this.$nextTick(() => {
                    // this.errors.clear();
                    this.$nextTick(() => {
                        // this.$validator.reset();
                        vm.d_none = true;
                        vm.copyDeliveryAddress = false;
                        vm.selectedDeliveryAddress = '';
                    });
                });
                // getting billing address
                vm.dropdownAddresses = '';
                AddressAPIService.getBillingAddresses( this.custId).then((response) =>  {
                    if(response.data.hasOwnProperty('billingAddresses')){
                        vm.dropdownAddresses = response.data.billingAddresses;
                    }
                })
            })

            this.$root.eventBus.on('BillingAddress::Add', (id=null) => {
                const vm = this;
                if(id){
                    this.custId = id;
                }
                this.name = '';
                this.address = '';
                this.address_2 = '';
                this.city = '';
                this.state = '';
                this.zip_code = '';
                this.email = '';
                this.phone = '';
                this.country = localStorage.getItem('BrandDefaultCurrency'); // We get brand default country through local storage
                this.action_mode = 'billing-address-add';
                this.copyTitle   = "Copy Same as Shipping Address";
                this.$nextTick(() => {
                    // this.errors.clear();
                    this.$nextTick(() => {
                        // this.$validator.reset();
                        vm.d_none = true;
                        vm.copyDeliveryAddress = false;
                        vm.selectedDeliveryAddress = '';
                    });
                });
                vm.dropdownAddresses = '';
                // getting shipping address
                AddressAPIService.getShippingAddress( this.custId).then((response) =>  {
                    if(response.data.hasOwnProperty('shippingAddresses')){
                        vm.dropdownAddresses = response.data.shippingAddresses;
                    }
                })
            })
            this.$root.eventBus.on('BillingAddress::Edit', (address) => {
                const vm = this;
                this.name = address.name;
                this.address = address.address;
                this.address_2 = address.address_2;
                this.city = address.city;
                this.state = address.state;
                this.zip_code = address.zip_code;
                this.email = address.email;
                this.phone = address.phone;
                this.country = address.country;
                this.addressId = address.id;
                this.action_mode = 'billing-address-edit';
                this.copyTitle   = "Copy Same as Shipping Address";
                this.selectedDeliveryAddress = '';
                vm.dropdownAddresses = '';
                // getting shipping address
                AddressAPIService.getShippingAddress( this.custId).then((response) =>  {
                    if(response.data.hasOwnProperty('shippingAddresses')){
                        vm.dropdownAddresses = response.data.shippingAddresses;
                    }
                })
            })

            var self = this;
            setTimeout(function(){
                AddressAPIService.getStates().then((response) => {
                    if(response.data.hasOwnProperty("states")){
                        self.states = response.data.states;
                    }
                    else if(response.data.hasOwnProperty("error")){
                        swal.fire("Error Exception!", response.data.error, "error");
                    }
                }).catch((error) => {
                    swal.fire("Error Exception!","Error", "error");
                });
            }, 3000);
        },
        methods: {
            changeSelectedAddress: function () {
                if(this.selectedDeliveryAddress != ""){
                    this.name      = this.selectedDeliveryAddress.name;
                    this.address   = this.selectedDeliveryAddress.address;
                    this.address_2 = this.selectedDeliveryAddress.address_2;
                    this.city      = this.selectedDeliveryAddress.city;
                    this.state     = this.selectedDeliveryAddress.state;
                    this.zip_code  = this.selectedDeliveryAddress.zip_code;
                    this.country   = this.selectedDeliveryAddress.country;
                    this.phone     = this.selectedDeliveryAddress.phone;
                    this.email     = this.selectedDeliveryAddress.email;
                }
            },
            saveAddress() {
                var data = {
                    name: this.name,
                    address: this.address,
                    address_2: this.address_2,
                    city: this.city,
                    state: this.state,
                    zip_code: this.zip_code,
                    country: this.country,
                    email: this.email,
                    phone: this.phone,
                };
                if (this.action_mode == 'shipping-address-add'){
                    this.spinner = true;
                    this.buttonDisable = true;
                    AddressAPIService.createShippingAddress(data, this.custId).then((response) => {
                        if(response.data.hasOwnProperty("success")){
                            $('#add_edit_vendor_model').modal('toggle');
                            // this.errors.clear();
                            this.notify("Success!",response.data.success, "success");
                            this.formReset();
                            this.$emit('addressToShowCustomer', 'shipping-address-saved');
                            $('.address-modal').modal('hide');
                            this.spinner = false;
                            this.buttonDisable = false;
                        }
                        else if(response.data.hasOwnProperty("error")){
                            this.formReset();
                            $('#add_edit_vendor_model').modal('toggle');
                            var errorsHtml = '';
                            $.each(response.data.error, function(index, error) {
                                errorsHtml += '<span class="invalid-feedback">' + error + '</span><br>';
                            });
                            this.notify("Error",errorsHtml,"error");
                            this.spinner = false;
                            this.buttonDisable = false;
                        }
                    }).catch((error) => {
                        this.notify("Error Exception!","Error", "error");
                        this.spinner = false;
                        this.buttonDisable = false;
                    });
                } else if (this.action_mode == 'shipping-address-edit'){
                    this.spinner = true;
                    this.buttonDisable = true;
                    AddressAPIService.updateShippingAddress(data, this.custId, this.addressId).then((response) => {
                        if(response.data.hasOwnProperty("success")){
                            // this.errors.clear();
                            this.notify("Success!",response.data.success, "success");
                            this.$emit('addressToShowCustomer', 'shipping-address-saved');
                            $('.address-modal').modal('hide');
                            this.spinner = false;
                            this.buttonDisable = false;
                        }
                        else if(response.data.hasOwnProperty("error")){
                            var errorsHtml = '';
                            $.each(response.data.error, function(index, error) {
                                errorsHtml += '<span class="invalid-feedback">' + error + '</span><br>';
                            });
                            this.notify("Error",errorsHtml,"error");
                            this.spinner = false;
                            this.buttonDisable = false;
                        }
                    }).catch((error) => {
                        this.notify("Error Exception!","Error", "error");
                        this.spinner = false;
                        this.buttonDisable = false;
                    });
                } else if(this.action_mode == 'billing-address-add') {
                    this.spinner = true;
                    this.buttonDisable = true;
                    AddressAPIService.createBillingAddress(data, this.custId).then((response) => {
                        if(response.data.hasOwnProperty("success")){
                            // this.errors.clear();
                            this.notify("Success!", response.data.success, "success");
                            this.formReset();
                            // trigger event for parent component.
                            this.$emit('addressToShowCustomer', 'billing-address-saved');
                            $('.address-modal').modal('hide');
                            this.spinner = false;
                            this.buttonDisable = false;
                        }
                        else if(response.data.hasOwnProperty("error")){
                            this.formReset();
                            var errorsHtml = '';
                            $.each(response.data.error, function(index, error) {
                                errorsHtml += '<span class="invalid-feedback">' + error + '</span><br>';
                            });
                            this.notify("Error",errorsHtml,"error");
                            this.spinner = false;
                            this.buttonDisable = false;
                        }
                    }).catch((error) => {
                        this.notify("Error Exception!","Error", "error");
                        this.spinner = false;
                        this.buttonDisable = false;
                    });
                } else if (this.action_mode == 'billing-address-edit'){
                    this.spinner = true;
                    this.buttonDisable = true;
                    AddressAPIService.updateBillingAddress(data, this.addressId, this.custId).then((response) => {
                        if(response.data.hasOwnProperty("success")){
                            // this.errors.clear();
                            this.notify("Success!",response.data.success, "success");
                            this.$emit('addressToShowCustomer', 'billing-address-saved');
                            $('.address-modal').modal('hide');
                            this.spinner = false;
                            this.buttonDisable = false;
                        }
                        else if(response.data.hasOwnProperty("error")){
                            var errorsHtml = '';
                            $.each(response.data.error, function(index, error) {
                                errorsHtml += '<span class="invalid-feedback">' + error + '</span><br>';
                            });
                            this.notify("Error",errorsHtml,"error");
                            this.spinner = false;
                            this.buttonDisable = false;
                        }
                    }).catch((error) => {
                        this.notify("Error Exception!","Error", "error");
                        this.spinner = false;
                        this.buttonDisable = false;
                    });
                }
            },
            onCountryChange(event) {
                this.country = event.target.value;
                if(this.country == 'United States'){
                    this.state = 'Alabama';
                } else{
                    this.state = '';
                }
            },
            // validateAddressBeforeSave() {
            //     this.spinner = true;
            //     this.buttonDisable = true;
            //     this.$validator.validate("deliveryAddress.*").then((result) => {
            //         if(!result){
            //             this.spinner = false;
            //             this.buttonDisable = false;
            //             return;
            //         }
            //         else{
            //             this.saveAddress();
            //         }
            //     });
            // },
            formReset()
            {
                // this.errors.clear();
                this.name = '';
                this.address = '';
                this.address_2 = '';
                this.city = '';
                this.state = '';
                this.zip_code = '';
                this.email = '';
                this.phone = '';
                this.country = '';
                // Clear vee-validate errors
                this.$refs.form.resetForm();
            },
        },
        beforeDestroy() {
            this.$root.eventBus.off('ShippingAddress::Edit');
            this.$root.eventBus.off('BillingAddress::Edit');
            this.$root.eventBus.off('ShippingAddress::Add');
            this.$root.eventBus.off('BillingAddress::Add');
        }
    };
</script>
<style scoped>
    .modal-header {
        background-color: #f7f7f7!important;
    }
    .invalid-feedbacks {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 0.9rem;
    color: #F64E60;
}
@media (max-width: 768px) {
    .modal-dialog {
        margin: 2rem 1rem;
        max-width: calc(100% - 2rem);
    }
    .modal-body {
        padding: 2.5rem !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
    .form-group.row > [class*='col-'] {
        padding-left: 0 !important;
        padding-right: 0 !important;
        margin-bottom: 1rem;
    }
    .modal-footer {
        flex-wrap: wrap;
        gap: 0.5rem;
    }
    .modal-footer .btn {
        flex: 1;
        min-width: 0;
    }
}
</style>
